import LegalLayout from "@/components/LegalLayout";

const PrivacyPolicyPage = () => (
  <LegalLayout eyebrow="Legal" title="Privacy Policy" updated="May 2026">
    <p>
      Allen Travels RD ("we", "our", "us") respects your privacy. This policy explains what information we collect when you use our website or services, how we use it, and the choices you have.
    </p>

    <h2>1. Information we collect</h2>
    <ul>
      <li><strong>Booking details</strong> — name, email, phone, pickup/dropoff locations, flight number, dates, and party size.</li>
      <li><strong>Payment information</strong> — processed securely by our payment partners (Stripe, PayPal). We never store full card numbers on our servers.</li>
      <li><strong>Technical data</strong> — IP address, browser type, and usage analytics to help us improve the experience.</li>
    </ul>

    <h2>2. How we use your information</h2>
    <ul>
      <li>To confirm, deliver, and support your booking.</li>
      <li>To send transactional emails (booking confirmations, vouchers, reminders).</li>
      <li>To improve our website, services, and customer support.</li>
      <li>To comply with legal obligations.</li>
    </ul>

    <h2>3. Sharing</h2>
    <p>
      We share your data only with the parties strictly necessary to deliver your service: assigned drivers, tour operators, and payment processors. We never sell your information.
    </p>

    <h2>4. Cookies</h2>
    <p>
      We use cookies for essential functionality and to understand how the site is used. See our <a href="/cookie-policy">Cookie Policy</a> for details.
    </p>

    <h2>5. Your rights</h2>
    <p>
      You may request access, correction, or deletion of your personal data at any time by writing to <a href="mailto:hello@allentravelsrd.com">hello@allentravelsrd.com</a>.
    </p>

    <h2>6. Security</h2>
    <p>
      We use industry-standard encryption and access controls. No system is perfectly secure, but we treat your data with the care it deserves.
    </p>

    <h2>7. Contact</h2>
    <p>
      Questions about this policy? Email us at <a href="mailto:hello@allentravelsrd.com">hello@allentravelsrd.com</a>.
    </p>
  </LegalLayout>
);

export default PrivacyPolicyPage;
